import React from "react";
import { OVEN_TYPE_SELECT } from "../../constance/dataTypes";
import PropTypes, { object } from "prop-types";
import { useTranslation } from "react-i18next";
import ErrorMessage from "../common/ErrorMessage";
import { GET } from "../../utils/HttpClient";
import { Form, Radio, Card, Input, List, Space, Spin, InputNumber } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { DATE_FORMAT } from "../../constance/strings";
import _, { join, values } from "lodash";


const OvenForm = React.forwardRef((props, ref) => {
  const {
    style,
    readOnly,
    setUrl,
    params,
    form,
  } = props;

  const { t } = useTranslation();
  const ovenNoRef = React.useRef();

  const [ovenSetList, setOvenSetList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const ovens = Form.useWatch('ovens', form)
  const groupDate = form.getFieldValue("post_baking_group_date");
  const [ovenTypeSelect, setOvenTypeSelect] = React.useState(OVEN_TYPE_SELECT.ALL)

  React.useImperativeHandle(ref, () => ({
    initial: initialOvenTypeSelect
  }))

  React.useEffect(() => {
    if (groupDate && ovenTypeSelect == OVEN_TYPE_SELECT.SET) {
      fetchOvenSet({ ...params, date: groupDate.format(DATE_FORMAT) });
    }
  }, [groupDate, ovenTypeSelect]);

  const fetchOvenSet = async () => {
    if (ovenSetList.length > 0) return;
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(setUrl, { ...params, date: groupDate.format(DATE_FORMAT) })
      setOvenSetList(response.data)

    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  const initialOvenTypeSelect = (ovens) => {
    if (!ovens || ovens.length === 0) {
      setOvenTypeSelect(OVEN_TYPE_SELECT.ALL);
    } else if (ovens.length === 1) {
      setOvenTypeSelect(OVEN_TYPE_SELECT.SPECIFIC);
    } else {
      setOvenTypeSelect(OVEN_TYPE_SELECT.SET);
    }
  };


  React.useEffect(() => {
    if (ovenTypeSelect == OVEN_TYPE_SELECT.SET) {
      fetchOvenSet()
    } else {
      setOvenSetList([]);
    }
  }, [ovenTypeSelect])

  return (
    <Form style={style} form={form} >
      <div style={{ width: 'fit-content', margin: 'auto', textAlign: 'left', marginTop: '2rem', marginBottom: '2rem' }}>

        <Form.Item hidden name='ovens' />
        <Radio.Group
          value={ovenTypeSelect}
          onChange={(e) => {
            setOvenTypeSelect(e.target.value)
            form.setFieldValue('ovens', [])
          }}
        >
          <Space direction='vertical'>
            <Radio value={OVEN_TYPE_SELECT.ALL} disabled={readOnly} >
              {t('post_baking_waste_wood_count.all_oven')}
            </Radio>
            <Radio value={OVEN_TYPE_SELECT.SPECIFIC} disabled={readOnly} >
              <Space direction='horizontal'>
                <span>{t('post_baking_waste_wood_count.specific_oven')}</span>
                <span>{t('post_baking_waste_wood_count.oven_no')}</span>
                <InputNumber
                  ref={ovenNoRef}
                  style={{ width: '70px' }}
                  placeholder={t('input')}
                  readOnly={readOnly}
                  value={form.getFieldValue('ovens')}
                  onChange={(value) => {
                    form.setFieldValue('ovens', [value]);
                  }} />
              </Space>
            </Radio>
            <Radio value={OVEN_TYPE_SELECT.SET} disabled={readOnly} >
              {t('post_baking_waste_wood_count.oven_set')}
            </Radio>
            {ovenTypeSelect == OVEN_TYPE_SELECT.SET && (
              <Card title={`${t('select')} ${t('post_baking_waste_wood_count.oven_set')}`} size="small">
                <Spin spinning={loading} tip={t('loading')} size="small" >
                  {errorMessages && <ErrorMessage message={errorMessages} />}
                  {ovenSetList.length > 0 ? (
                    <Radio.Group
                      value={JSON.stringify(ovens)}
                      onChange={(e) => {
                        const value = JSON.parse(e.target.value)
                        form.setFieldValue('ovens', value)
                      }}
                    >
                      {ovenSetList.map((ovenSet, index) => {
                        return (
                          <List.Item key={index}>
                            <Radio value={JSON.stringify(ovenSet)}>
                              {ovenSet.join(', ')}
                            </Radio>
                          </List.Item>
                        )
                      })}
                    </Radio.Group>
                  ) : (<Title disabled level={4}><SearchOutlined />{t('empty')}</Title>)}

                </Spin>
              </Card>
            )
            }

          </Space>
        </Radio.Group>
      </div>
    </Form >
  )
})

export default OvenForm;

OvenForm.propTypes = {
  style: PropTypes.object,
  setUrl: PropTypes.string,
  params: PropTypes.object,
  form: PropTypes.object,
}

OvenForm.defaultProps = {
  style: {},
  setUrl: '',
  params: {},
  form: {},
}